// src/data/artists-data.ts

export interface ArtistProjectData {
  imgSrc: string | null;
  imgSrcSmall: string | null;
  title: string;

  vimeoID?: string;
  youtubeID?: string;
  bgImgSrc169?: string;
  externalLink?: string;
  externalLinkCTA?: string;

  description: string;
  client: string;
}

export const artistProjectDataEmpty: ArtistProjectData = {
  imgSrc: null,
  imgSrcSmall: null,
  title: 'ARTIST',
  description: '',
  client: 'Artist'
};

export const artistProjectData: Array<ArtistProjectData> = [
  {
    title: 'Montaigne',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FMontaigne_big.jpg?alt=media&token=2115a5cc-bb5a-46ef-b82e-92f988c9d711',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/actualmontaigne', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Briggs',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FBriggs-%20865x486.jpeg?alt=media&token=6c80eee1-bcc0-4990-bf41-7323b5adfe02',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/senatorbriggs', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Casey Donovan',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FCasey_Donovan_big.jpg?alt=media&token=2e91e700-9e9a-444d-bbf1-351947341f56',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/caseydonovan88', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Josh Moreland',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FJosh_Moreland_big.jpg?alt=media&token=83213587-5583-4dac-be1d-130bdf3ca080',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/joshmoreland', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Marcia Hines',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FMarcia_Hines_big.jpg?alt=media&token=0b7a0101-41ed-44d3-94ff-edd15f80d26f',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/themarciahines', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Marieme',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FMarieme_big.jpg?alt=media&token=f966029c-f0ec-4ec1-b6bf-08de3d3e0e52',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/mariememusic', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Shane Nicholson',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FShane_Nicholson_big.jpg?alt=media&token=abb33ea9-410f-45f5-8292-cf14d4efc672',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/shanenicholson', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Sia',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FSia_big.jpg?alt=media&token=2fc339e2-5037-4451-8bf2-0dcb42daa125',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/siamusic', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Toby Rand',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FToby_Rand_big.jpg?alt=media&token=a0633071-92fa-43f8-9dc8-0efe499dda7c',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/tobyrand', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Vassy',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FVassy_big.jpg?alt=media&token=be8c6143-6854-4cc7-8793-9212032da085',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/vassymusic', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Vera Blue',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FVera_Blue_big.jpg?alt=media&token=09708f3e-0e63-428a-b8ff-4e6621d1ecc6',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/verabluemusic', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Darren Hayes',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FDarren_Hayes_big.jpeg?alt=media&token=f8989543-882f-42aa-a90a-21f4d702780e',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/darrenhayes', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },

  // TESTING
  {
    title: 'Amber Lawrence',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2Famberlawrence_%20865%20x%20486.jpeg?alt=media&token=7c627bd5-83b7-4cc4-b3a8-f30de562a6f6',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/amberlawrencemusic', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Guy Sebastien',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FGuy-Sebastian-865x486.jpeg?alt=media&token=31119d79-c58a-4475-b2a2-c61d21241815',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/guysebastian', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Kate Miller-Heidke ',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2Fkate-miller-heidke%20865%20x%20486.jpeg?alt=media&token=a26a642c-ba69-4317-a3e5-b466a925dbdd',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/katemillerheidke/', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },

  {
    title: 'A.Girl',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FA_girl_865%20x%20486.jpeg?alt=media&token=db4dfca3-774a-4822-8215-d6f3f5a2ae12',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/agirlartist', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Sarah Basko',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FSarah-Blasko-scaled%20865%20x%20486.jpeg?alt=media&token=93feb98f-6964-4e52-8e4e-bb3267393bf3',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/sarahblasko', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Francci Richard',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FFrancci%20Richard%20865%20x%20486.jpeg?alt=media&token=92063f8c-0979-45f8-ab17-a64a53a10c95',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/penzillathegreat', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Dallas Woods',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FDallas%20Woods_3%20865%20x%20486.jpeg?alt=media&token=6da7aa79-f2ea-45eb-8ec2-6d5c35542c12',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/woods.dallas', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Tima Dee',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FTima%20Dee%20865%20x%20486.jpeg?alt=media&token=1ff30322-acfa-4a70-9aad-9aa84ab4d0a9',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/tima_dee', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Kirsten Collins',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FKirsten%20collins_865x486.jpeg?alt=media&token=f91593ad-1089-4d50-b726-dd08f96daf17',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/kirstencollins', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Samantha Jade',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FSam%20JAde_865x486.jpeg?alt=media&token=ae9cc003-7dc8-413d-966a-9c878f7ecaa6',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/samanthajade', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Reigan Derry',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FREIGAN-DERRY-ARTIST%20865%20X%20486.jpeg?alt=media&token=03a13139-b253-40a1-9102-d06980dd25c5',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/reigan', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  {
    title: 'Chris Deyo Braun',
    client: 'Artist',
    imgSrc:
      'https://firebasestorage.googleapis.com/v0/b/uncanny-valley-site.appspot.com/o/projects%2F1024x640%2FNew%20Pics%20091125%2FChris%20Deyo%20Braun%20865%20x%20486.jpeg?alt=media&token=c6beff98-7423-406e-a43e-9aa9106ce827',
    imgSrcSmall: null,
    externalLink: 'https://www.instagram.com/chrisdeyobraun', // verify handle
    externalLinkCTA: 'Instagram',
    description: ''
  },
  
];